import { commonTransform } from "../handleTransformation";
import { GET_TOUCHPOINT_INSTANCE_EFFECTIVENESS, RUN_TOUCHPOINT_INSTANCE, UPDATE_TOUCHPOINT_INSTANCE_SEND_REMINDER, RETRIGGER_MEETING_SLOTS_LINK_URL, GET_FEEDBACK_INFO_URL } from "services/url.service";
import { tags } from "../constants";
export const touchpointInstancesMutations = {
  runTouchPointInstance: {
    getUrl: (touchPointInstanceId, isPostJoining) => {
      return RUN_TOUCHPOINT_INSTANCE(touchPointInstanceId, isPostJoining);
    },
    transformResponse: (res) => commonTransform(res),
    method: "POST",
  },
  updateTouchPointInstanceSendReminder: {
    getUrl: (touchPointInstanceId) => {
      return UPDATE_TOUCHPOINT_INSTANCE_SEND_REMINDER(touchPointInstanceId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags:[tags.TOUCH_POINT_INSTANCE]
  },
  retriggerMeetingSlotsLink: {
    getUrl: (touchPointInstanceId) => {
      return RETRIGGER_MEETING_SLOTS_LINK_URL(touchPointInstanceId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags:[tags?.TOUCH_POINT_INSTANCE]
  },
};

export const touchpointInstancesQueries = {
  getTouchPointInstanceEffectiveness: {
    getUrl: ({filters , companyId}) => {
        return GET_TOUCHPOINT_INSTANCE_EFFECTIVENESS(companyId, filters)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getFeedbackInfo: {
    getUrl: ({ touchPointInstanceId, hash, timeSlotId }) =>
      GET_FEEDBACK_INFO_URL(touchPointInstanceId, hash, timeSlotId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
};
